<template>
  <div>
    <v-row dense>
      <v-col xs="12" sm="4" md="4">
        <v-row dense>
          <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="d-sm-inline-block">
            <c-input
              class="ml-2"
              :label="'Nº Pedido'"
              :placeholder="'Nº Pedido'"
              :maxLength="8"
              :dark="!switchTheme"
              v-model="filter.text"
              clearable
            />
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="d-sm-inline-block">
            <c-select-multiple
              class="ml-2"
              itemText="title"
              itemValue="value"
              :lista="filters"
              :rotulo="'Filtros'"
              :size="filter.selectedFilters.length"
              :item.sync="filter.selectedFilters"
              v-model="filter.selectedFilters"
              :dark="!switchTheme"
            >
            </c-select-multiple>
          </v-col>
        </v-row>
        <v-card class="scroll" :height="cardItemHeight">
          <div
            v-if="filteredPollingList.length <= 0"
            class="d-flex justify-center"
          >
            Não há eventos para exibir
          </div>
          <div
            v-else
            v-for="event in filteredPollingList"
            :key="event.index"
            dense
          >
            <OrderItem
              :event="event"
              :id="event.index"
              :btnAction="submitOrderAction"
              @selected-order="setOrderPolling"
            />
          </div>
        </v-card>
      </v-col>
      <v-col cols="8">
        <v-card class="scroll" :max-height="cardDetailHeight">
          <OrderDetails
            v-if="
              filteredPollingList.length > 0 &&
                orderPolling &&
                orderPolling != {}
            "
            :btnAction="submitOrderAction"
          />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OrderItem from '@/views/integration/ifood/OrderList/OrderItem'
import OrderDetails from '@/views/integration/ifood/OrderList/OrderDetails'
import cInput from '@/components/shared/base-input/BaseInput'
import cSelectMultiple from '@/components/shared/base-input/BaseSelectMultiple.vue'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'OrderList',
  components: {
    OrderItem,
    OrderDetails,
    cInput,
    cSelectMultiple,
  },

  props: {
    switchTheme: Boolean,
    pollingList: Array,
    orderTiming: {
      type: String,
      default: 'IMMEDIATE',
    },
  },
  computed: {
    ...mapState('ifoodModule', [
      'optionsToCancelOrder',
      'orderPolling',
      'eventPolling',
    ]),
    cardItemHeight() {
      return this.fullscreenItem[this.$vuetify.breakpoint.name]
    },
    cardDetailHeight() {
      return this.fullscreenDetail[this.$vuetify.breakpoint.name]
    },

    filteredPollingList() {
      if (!this.pollingList) return []

      const list =
        this.filter.text && this.filter.text.length > 0
          ? this.pollingList.filter(
              (event) => event.order.displayId.indexOf(this.filter.text) !== -1
            )
          : this.pollingList

      const filtered =
        this.filter.selectedFilters.length > 0
          ? list.filter(
              (order) =>
                this.filter.selectedFilters.filter(
                  (s) => s.value == order.code
                )[0]
            )
          : list

      const orders = filtered.filter((event) => event.code != 'CAR')

      return orders.sort(function(a, b) {
        return b.index - a.index
      })
    },
  },
  data() {
    return {
      selected: null,
      infoCard: '',
      filter: {
        text: '',
        selectedFilters: [],
      },
      filters: [
        { title: 'Pendentes', value: 'PLC' },
        { title: 'Confirmados', value: 'CFM' },
        { title: 'Em entrega', value: 'DSP' },
        { title: 'Pedido Pronto', value: 'RTP' },
        { title: 'Concluídos', value: 'CON' },
        // { title: 'Cancelados por Requisição', value: 'CAR' },
        { title: 'Cancelados', value: 'CAN' },
      ],
      fullscreenItem: {
        xs: '100vh',
        sm: '60vh',
        md: '62vh',
        lg: '68vh',
        xl: '78vh',
      },
      fullscreenDetail: {
        xs: '100vh',
        sm: '60vh',
        md: '62vh',
        lg: '82vh',
        xl: '88vh',
      },
    }
  },
  methods: {
    ...mapActions({
      confirmOrderIfood: 'ifoodModule/confirmOrder',
      startPreparationOrderIfood: 'ifoodModule/startPreparationOrder',
      readyToPickupOrderIfood: 'ifoodModule/readyToPickupOrder',
      dispatchOrderIfood: 'ifoodModule/dispatchOrder',
      acceptCancellationIfood: 'ifoodModule/acceptCancellation',
      denyCancellationIfood: 'ifoodModule/denyCancellation',
      setOrderPolling: 'ifoodModule/setOrderPolling',
      updateList: 'ifoodModule/updateList',
      // Loading Dialog Module
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
    }),
    async submitOrderAction(action, event) {
      if (
        await this.$root.$confirm(
          this.$i18n.t(`ifood.buttons.${action}`),
          this.$i18n.t('dialogs.actions', {
            action: this.$i18n.t(`ifood.buttons.${action}`),
            nome: 'Pedido',
            codigo: event.order.displayId,
          }),
          { color: 'success' }
        )
      ) {
        try {
          this.setLoadingDialogMessage('Enviando requisição...')
          this.showLoadingDialog(true)
          const payload = {
            id: event.id,
            orderId: event.order.id,
          }
          const { data } = await this[`${action}Ifood`](payload)

          if (data.error) throw data.error
          else {
            this.updateList({
              action: action,
              event: event,
            })
            this.$toasted.success(data, { duration: 5000 })
          }
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        } finally {
          this.showLoadingDialog(false)
        }
      } else {
        return
      }
    },
  },
}
</script>

<style scoped>
.scroll {
  overflow-y: scroll;
}
</style>
